import React, { useState, useCallback } from "react";
import ComplaintDeductionService from "../../../../services/ComplaintDeduction";
import Button from "../../../../components/Button";
import Badge from "../../../../components/Badge";
import { Toast } from "../../../../config/Toast";
import { toast } from "react-toastify";
import { Checkbox } from "primereact/checkbox";

function BodyTable({ data, index, pageNumber, limitDataPages, getNewData, startDate, endDate }) {
  const [complaintsState, setComplaintsState] = useState(
    Array.isArray(data?.items) ? data?.items?.map((item) => ({ ...item })) : []
  );

  const [showInputValueAmount, setShowInputValueAmount] = useState(null);
  const [showInputValueProjectId, setShowInputValueProjectId] = useState(null);
  const [addNewProjectId, setAddProjectId] = useState("");
  const [valueDeduction, setValueDeduction] = useState("");

  const complaints = complaintsState;

  const notifySuccess = useCallback((message) => toast.success(message, Toast), []);
  const notifyFailed = useCallback((message) => toast.error(message, Toast), []);

  // Height
  const baseHeight = 40;
  const dynamicHeight = complaintsState.length > 0 ? baseHeight * complaintsState.length : baseHeight;
  const dynamicStyle = {
    minHeight: `${dynamicHeight}px`,
    maxHeight: `${dynamicHeight}px`,
    height: `${dynamicHeight}px`,
  };

  const getRowBackground = (index) => (index % 2 === 0 ? "#fcfcfc" : "#ffffff");

  const widthStyle = {
    no: {
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      flexShrink: "0",
      position: "sticky",
      left: "0",
    },
    worker_id: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      left: "80px",
    },
    worker_name: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      flexShrink: "0",
      position: "sticky",
      left: "215px",
    },
    worker_type: { width: "100%", minWidth: "200px", maxWidth: "100%" },
    initial_amount: { width: "100%", minWidth: "200px", maxWidth: "100%" },
    project_id: { width: "100%", minWidth: "200px", maxWidth: "100%" },
    amount_complain: { width: "100%", minWidth: "200px", maxWidth: "100%" },
    final_amount: { width: "100%", minWidth: "200px", maxWidth: "100%" },
    action: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      right: "0",
      backgroundColor: "#f8f8f8",
    },
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(value || 0);

  const handleEditClickAmount = (i, currentValue) => {
    setShowInputValueAmount(i);
    setValueDeduction(currentValue?.toString() || "");
  };

  const handleValueChangeAmount = (e) => {
    const rawValue = e.target.value.replace(/[^\d]/g, "");
    setValueDeduction(rawValue);
  };

  const handleEditClickProjectId = (i, currentValue) => {
    setShowInputValueProjectId(i);
    setAddProjectId(currentValue?.toString() || "");
  };

  const handleValueChangeProjectId = (e) => {
    const rawValue = e.target.value.replace(/[^\d]/g, "");
    setAddProjectId(rawValue);
  };

  const handleSave = async (i, id, itemId, deduction, projectId) => {
    const updated = [...complaintsState];
    const updatedItem = {
      ...updated[i],
      project_id: addNewProjectId || updated[i].project_id,
      deduction: Number(valueDeduction) || updated[i].deduction || deduction || 0,
    };
    updated[i] = updatedItem;
    setComplaintsState(updated);

    setShowInputValueAmount(null);
    setShowInputValueProjectId(null);

    if (id && itemId && projectId && deduction >= 0) {
      try {
        await HandleEdit(id, itemId, deduction);
      } catch (error) {
        notifyFailed(error?.response?.data?.message || "Error updating complain wages");
      }
    } else {
      return;
    }
  };

  const handleDelete = async (id, itemId) => {
    try {
      await ComplaintDeductionService.delete(id, itemId);
      notifySuccess(`Success deleted complain wages`);
    } catch (error) {
      console.error("Error deleting complain wages:", error);
      notifyFailed(error?.response?.data?.message || "Error deleting complain wages");
    } finally {
      resetFormState();
      getNewData();
    }
  };

  const resetFormState = () => {
    setShowInputValueAmount(null);
    setShowInputValueProjectId(null);
    setAddProjectId("");
    setValueDeduction("");
  };

  const HandleEdit = async (id, itemId, deduction) => {
    if (deduction === Number(valueDeduction) || !id || !itemId) {
      return;
    }
    try {
      await ComplaintDeductionService.edit(id, {
        item_id: Number(itemId),
        amount: Number(valueDeduction) || 0,
      });
      notifySuccess(`Success updated complain wages`);
    } catch (error) {
      console.error("Error updating complain wages:", error);
      notifyFailed(error?.response?.data?.message || "Error updating complain wages");
    } finally {
      resetFormState();
      getNewData();
    }
  };

  const HandleAdd = async (id, index) => {
    try {
      await ComplaintDeductionService.add(id, {
        project_id: addNewProjectId,
        amount: Number(valueDeduction) || 0,
      });
      notifySuccess(`Success added complain wages`);
    } catch (error) {
      notifyFailed(error?.response?.data?.message || "Error add complain wages");
    } finally {
      handleRemoveItem(index);
      resetFormState();
      getNewData();
    }
  };

  const handleAddItem = () => {
    const newItem = {
      id: "",
      project_id: "",
      mark: 0,
      deduction: 0,
      is_edit: true,
    };
    setComplaintsState((prev) => [...prev, newItem]);
  };

  const handleCheckboxChange = async (index, checked, id) => {
    setComplaintsState((prev) => {
      const updated = [...prev];
      updated[index].mark = checked ? 1 : 0;
      return updated;
    });

    try {
      await ComplaintDeductionService.checklist(data.id, id, checked ? 1 : 0);
      notifySuccess(`Success updated checklist`);
    } catch (error) {
      checked = 0;
      console.error("Error updating checklist:", error);
      notifyFailed(error?.response?.data?.message || "Error updating checklist");
    } finally {
      resetFormState();
      getNewData();
    }
  };

  const handleRemoveItem = (index) => {
    setComplaintsState((prev) => prev.filter((_, i) => i !== index));
    setAddProjectId(null);
    setValueDeduction(null);
  };

  if (!data) {
    return (
      <div className="text-center text-muted">
        <h6>Loading data...</h6>
      </div>
    );
  }

  return (
    <>
      {/* No */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.no, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {(pageNumber - 1) * limitDataPages + index + 1}
          </h6>
        </div>
      </div>

      {/* Worker ID */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_id, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_id ?? "-"}
          </h6>
        </div>
      </div>

      {/* Worker Name */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_name, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_name ?? "-"}
          </h6>
        </div>
      </div>

      {/* Worker Type */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.worker_type, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {data.worker_type ?? "-"}
          </h6>
        </div>
      </div>

      {/* Amount */}
      <div
        className="flex flex-row justify-content-start align-items-start border-right-1 border-200"
        style={{ ...widthStyle.initial_amount, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {formatCurrency(data.initial_amount)}
          </h6>
        </div>
      </div>

      {/* Project ID Complain (nested) */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.project_id, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints?.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-between align-items-center w-full text-center p-3 ${
                index !== complaints?.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{ minHeight: baseHeight, maxHeight: baseHeight, height: baseHeight }}
            >
              {showInputValueProjectId === index && complain?.is_edit === true ? (
                <input
                  type="text"
                  autoFocus
                  value={addNewProjectId ? addNewProjectId : ""}
                  onChange={handleValueChangeProjectId}
                  onBlur={() => handleSave(index, complain.id)}
                  onKeyDown={(e) => e.key === "Enter" && handleSave(index, complain.id)}
                  className="form-control text-xs text-left fw-bold m-0"
                  placeholder="Project ID"
                  style={{ height: "35px", maxWidth: "80%", padding: "0 0", background: "transparent" }}
                />
              ) : (
                <h6 className={`m-0 p-0 m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
                  {complain.project_id ?? "-"}
                </h6>
              )}

              {complain?.is_edit === true && data.is_posting === 0 && (
                <div
                  className="p-0 m-0 cursor-pointer flex flex-row justify-content-center align-items-center h-full"
                  onClick={() => handleEditClickProjectId(index, complain.project_id)}
                >
                  <i className="fa fa-edit p-0 m-0" style={{ fontSize: "16px" }}></i>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="flex flex-row justify-content-start align-items-center w-full p-3">
            <h6 className={`m-0 p-0 m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>-</h6>
          </div>
        )}
      </div>

      {/* Kolom Amount Complain */}
      <div
        className="flex flex-column justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.amount_complain, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints?.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-between align-items-center w-full text-center p-3 ${
                index !== complaints?.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{ minHeight: baseHeight, maxHeight: baseHeight, height: baseHeight }}
            >
              {showInputValueAmount === index ? (
                <input
                  type="text"
                  autoFocus
                  value={valueDeduction ? formatCurrency(valueDeduction) : ""}
                  onChange={handleValueChangeAmount}
                  onBlur={() => handleSave(index, data.id, complain.id, complain.deduction)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && handleSave(index, data.id, complain.id, complain.deduction, complain.project_id)
                  }
                  placeholder={formatCurrency(valueDeduction)}
                  className="form-control text-xs text-left fw-bold m-0"
                  style={{ height: "35px", maxWidth: "80%", padding: "0 0", background: "transparent" }}
                />
              ) : (
                <h6
                  className={`m-0 p-0 fw-bold text-xs ${
                    complain.deduction > 0 ? "text-danger" : data.is_posting === 1 ? "color-primary" : ""
                  }`}
                >
                  {`${complain.deduction > 0 ? "-" : ""}${formatCurrency(complain.deduction)}`}
                </h6>
              )}

              {data.is_posting === 0 && (
                <div
                  className="p-0 m-0 cursor-pointer flex flex-row justify-content-center align-items-center h-full"
                  onClick={() => handleEditClickAmount(index, complain.deduction)}
                >
                  <i className="fa fa-edit p-0 m-0" style={{ fontSize: "16px" }}></i>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="flex flex-row justify-content-start align-items-center w-full p-3">
            <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>-</h6>
          </div>
        )}
      </div>

      {/* Total */}
      <div
        className="flex flex-row justify-content-start align-items-start"
        style={{ ...widthStyle.final_amount, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className={`m-0 p-0 fw-bold text-xs ${data.is_posting === 1 ? "color-primary" : ""}`}>
            {formatCurrency(data.final_amount)}
          </h6>
        </div>
      </div>

      {/* Action (checkbox) */}
      <div
        className="flex flex-column justify-content-center align-items-start border-left-1 border-200"
        style={{ ...widthStyle.action, ...dynamicStyle, backgroundColor: getRowBackground(index) }}
      >
        {complaints?.length > 0 ? (
          complaints.map((complain, index) => (
            <div
              key={index}
              className={`flex flex-row justify-content-start align-items-center w-full text-center gap-2 px-3 ${
                index !== complaints?.length - 1 ? "border-bottom-1 border-200" : ""
              }`}
              style={{
                minHeight: baseHeight,
                background: complain.mark === 1 ? "rgb(46, 187, 169, 0.15)" : "",
              }}
            >
              {data.is_posting === 0 ? (
                <>
                  {!complain?.is_edit && (
                    <Button button="btn-primary btn-sm p-0 " title="+" onClick={() => handleAddItem(index)}></Button>
                  )}

                  {addNewProjectId && valueDeduction && complain?.is_edit && (
                    <Button button="btn-success btn-sm p-0 " title="+" onClick={() => HandleAdd(data.id, index)}></Button>
                  )}

                  {complain.id && !complain?.is_edit && (
                    <Button button="btn-danger btn-sm p-0" title="-" onClick={() => handleDelete(data.id, complain.id)} />
                  )}

                  {!complain.id && complain?.is_edit && (
                    <Button button="btn-danger btn-sm p-0" title="-" onClick={() => handleRemoveItem(index)} />
                  )}

                  {!complain?.is_edit && (
                    <Checkbox
                      disabled={data.is_posting === 1}
                      checked={complain.mark === 1}
                      onChange={(e) => handleCheckboxChange(index, e.checked, complain.id)}
                    />
                  )}
                </>
              ) : (
                <Badge badge="bg-primary text-white pt-1" name="posted" type="rounded-pill" />
              )}
            </div>
          ))
        ) : (
          <div className="px-3 w-full">
            {data.is_posting === 0 ? (
              <Button button="btn-primary btn-sm p-0" title="+" onClick={() => handleAddItem(index)} />
            ) : (
              <Badge badge="bg-primary text-white pt-1" name="posted" type="rounded-pill" />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default BodyTable;
